import { IFloatingFilterAngularComp } from '@ag-grid-community/angular';
import { FilterChangedEvent, IFloatingFilterParams } from '@ag-grid-community/core';
import { Component, ElementRef, ViewEncapsulation } from '@angular/core';
import { ChipFilterComponent } from '../../filters/chip-filter/chip-filter.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'tt-chip-floating-filter',
    templateUrl: './chip-floating-filter.component.html',
    styleUrls: ['./chip-floating-filter.component.css'],
    encapsulation: ViewEncapsulation.None,
})
export class ChipFloatingFilterComponent implements IFloatingFilterAngularComp {
    public params?: IFloatingFilterParams<ChipFilterComponent>;

    public instance?: ChipFilterComponent;

    private subscription?: Subscription;

    selectedNamesTooltip = '';

    constructor(private elementRef: ElementRef<HTMLElement>) {}

    agInit(params: IFloatingFilterParams<ChipFilterComponent>): void {
        console.log(params);
        console.log(params.currentParentModel());
        params.parentFilterInstance((instance) => {
            this.instance = instance;
            console.log('this.instance.getModel() :>> ', this.instance.getModel());
            if (!this.subscription) {
                this.subscription = this.instance.selectedNames$.subscribe({ next: (value) => (this.selectedNamesTooltip = this.getSelectedNamesTooltip(value)) });
            }
        });
        this.params = params;
    }

    onParentModelChanged(parentModel: string[] | null, filterChangedEvent?: FilterChangedEvent | null): void {
        this.selectedNamesTooltip = this.getSelectedNamesTooltip(parentModel);
    }

    private getSelectedNamesTooltip = (value: string[] | null): string => {
        const { width } = this.elementRef.nativeElement.getBoundingClientRect();
        console.log('width :>> ', width);
        return '';
        // return value?.reduce((acc, name) => acc + ', \n' + name, '').substring(3) ?? '';
    };
}
